<template>
    <div class="productsOuterWrapper" v-if="productArray.length != 0">
        <br>
        <hr>
        <div class="productsInnerWrapper">
        <div class="product" v-for="product in productArray" :key="product.productID">
            <a :href="basedir+'/'+product.productPageLink">            
            <img :src="product.imageUrl">
            <div class="productName">
            <p v-html="product.name"></p>
            </div>
            </a>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["videoId", "tags"],
    data() {
        return {
            productArray: [],
        }
    },
    async mounted() {
        this.$nextTick(() => {
            if (typeof this.tags != 'undefined') {
                this.tags.forEach(tag => {
                    axios.get(basedir + '/ajaxRequestServlet?mode=GetProduct&isSpecial=true&payload={productID:%20' + tag + ',%20isPointShop:false}').then(response => {
                        this.productArray.push(response.data)
                    })

                })
            }

        })
    },
    methods: {
        IsJsonString(str) {
            try {
                JSON.parse(str.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
            } catch (e) {
                return false;
            }
            return true;
        }
    },
    computed: {
        basedir: function() {
            return basedir;
        }
    }
}
</script>

<style lang="scss" scoped>
.productsOuterWrapper{

}
.productsInnerWrapper{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-template-rows: auto;
    justify-content: start;
    grid-gap: 10px;
    padding: 30px 0px;
}
.product {
    border: 1px solid #004570;
    background: #ebebeb;
    border-radius: 5px;
    transition: all 0.2s ease-in-out;

    box-shadow: 0px 0px 9px #0000008c;
    display: flex;
    &:hover {
        img{
            transform: scale(1.05)
        }
        //transform: scale(1.02)
    }
    a{
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
    }
        .productName{
            background: #004570;
            height: 100%;
        }
    img {
        width: 100%;
        transition: all 0.2s ease-in-out;
    }
    p {
        padding: 10px;

        margin: 0;
        color: white;
        font-weight: bold;
    }
}
</style>